import { format, getTime, formatDistanceToNow, differenceInYears, isValid } from 'date-fns';
import i18n from "i18next";

// ----------------------------------------------------------------------
export function printLAstDate(date) {
  const dateformat = new RegExp("(\\d{4})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "g");
  let ddr = '';
  const match = dateformat.exec(date);
  if (match) {
    ddr = `${match[3]}/${match[2]}/${match[1]} à ${match[4]}:${match[5]}`;
  }
  return ddr;
}
export function printDate(date) {
  const dateformat = new RegExp("(\\d{4})(\\d{2})(\\d{2})", "g");
  let ddr = '';
  const match = dateformat.exec(date);
  if (match) {
    ddr = `${match[3]}/${match[2]}/${match[1]}`;
  }
  return ddr;
}
export function dateIsValid(date) {
  return !Number.isNaN(new Date(date).getTime());
}
export function convertToDate(date) {
  const dateformat = new RegExp("(\\d{4})(\\d{2})(\\d{2})", "g");
  const match = dateformat.exec(date);

  if (match) {
    return new Date(`${match[1]}-${match[2]}-${match[3]}`);
  }
  return null;
}

export function oldYears(date) {
  return differenceInYears(new Date(), new Date(date));
}

export function fDate(date, formated = 'dd/MM/yyyy') {
  if (date && dateIsValid(date))
    return format(new Date(date), formated);
  return '';
}

export function fDateTime(date) {
  if (date && dateIsValid(date))
    return format(new Date(date), "dd/MM/yyyy 'T' HH:mm");
  return null;
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function validateDates({ start, end, startLabel = 'START_DATE', endLabel = 'END_DATE' }) {
  const date2 = new Date('01/01/1900').getTime();
  const now = new Date().getTime();
  const errors = {};
  if (start > now)
    errors[startLabel] = i18n.t("errors.invalidFutureDate");
  if (end > now)
    errors[endLabel] = i18n.t("errors.invalidFutureDate");

  if (!dateIsValid(start))
    errors[startLabel] = i18n.t("errors.invalidDate");
  if (!dateIsValid(end))
    errors[endLabel] = i18n.t("errors.invalidDate");

  if (end < start && !!end && !!start) {
    errors[startLabel] = i18n.t("errors.dateLessError");
    errors[endLabel] = i18n.t("errors.dateLessError");
  }
  if (end < date2)
    errors[endLabel] = i18n.t("errors.invalidMinDate");
  if (start < date2)
    errors[startLabel] = i18n.t("errors.invalidMinDate");
  return errors;
}

export function getDateTimeValue({ dateValue, hourValue }) {
  if (dateValue && hourValue) {
    // Format dateValue and hourValue to match "yyyy-MM-dd'T'HH:mm"
    const formattedDate = fDate(dateValue, "yyyy-MM-dd'T'HH:mm");
    const formattedHour = fDate(hourValue, "yyyy-MM-dd'T'HH:mm");

    if (!formattedDate || !formattedHour) {
      return 0;
    }

    // Create Date objects from the formatted strings
    const date = new Date(formattedDate);
    const hourDate = new Date(formattedHour);

    // Extract hours and minutes from hourDate
    const hour = hourDate.getHours();
    const min = hourDate.getMinutes();

    // Set the hours and minutes on the date object
    date.setHours(hour);
    date.setMinutes(min);

    return date.getTime();
  }

  return 0; // Return 0 if dateValue or hourValue are missing
}

export function calculateAge(dateOfBirth) {
  const birthDate = new Date(dateOfBirth);
  const today = new Date();

  // Calculate the difference in milliseconds
  const diff = today - birthDate;

  // Convert the difference to days
  const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (diffDays <= 30) {
    if (diffDays === 1)
      return `${diffDays} jour`;

    return `${diffDays} jours`;
  }



  const diffMonths = Math.floor(diffDays / 30.44); // Average days in a month
  if (diffDays > 30 && diffMonths < 12) {
    return `${diffMonths} mois`;
  }

  const diffYears = Math.floor(diffMonths / 12);
  if (diffMonths >= 12) {
    return `${diffYears} ans`;
  }

  return 'Date de naissance invalide';
}
export const monthMapping = {
  '01': 'janv',
  '02': 'fev',
  '03': 'mars',
  '04': 'avr',
  '05': 'mai',
  '06': 'juin',
  '07': 'juil',
  '08': 'août',
  '09': 'sept',
  '10': 'oct',
  '11': 'nov',
  '12': 'déc'
};
export function formatDateTimeString(dateString) {
  const daysOfWeek = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];

  // Remplace " a " par "T" pour séparer la date et l'heure
  const cleanedDateString = dateString.replace(' a ', 'T').replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');

  // Crée un objet Date à partir de la chaîne nettoyée
  const inputDate = new Date(cleanedDateString);
  if (!isValid(inputDate)) {
    return '';
  }

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const inputDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());

  const timeDifference = today - inputDay;
  const dayDifference = timeDifference / (1000 * 3600 * 24);

  const hasTime = cleanedDateString.includes('T');

  if (dayDifference === 0) {
    // Si la date est aujourd'hui
    return hasTime ? inputDate.toTimeString().slice(0, 5) : now.toLocaleDateString('fr-FR');
  }

  if (dayDifference > 0 && dayDifference <= 6) {
    // Si la date est entre hier et il y a 6 jours
    const dayOfWeek = daysOfWeek[inputDate.getDay()];
    return hasTime ? `${dayOfWeek} ${inputDate.toTimeString().slice(0, 5)}` : inputDate.toLocaleDateString('fr-FR');
  }
  // Si la date est plus ancienne qu'il y a 7 jours
  return inputDate.toLocaleDateString('fr-FR');

}